import { AnalyticsProductDto } from "@intelligems/ig-types/dtos/analytics-products";
import { fromGqlId } from "@src/api/formatters/shopify";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import {
  getAnalyticsProducts,
  setAnalyticsProducts,
} from "@src/store/slices/analyticsProducts";
import { selectedExperience } from "@src/store/slices/experiences";
import { ShopifyProduct } from "@src/store/slices/products/types";
import { updateProducts } from "@src/store/slices/products/util/updateProducts";

export const updateAnalyticsProducts = createAsyncThunk<void, string[]>(
  "analyticsProducts/updateAnalyticsProducts",
  async (productIds, { dispatch, getState }) => {
    const analyticsProducts = getAnalyticsProducts(getState());
    const experience = selectedExperience(getState());

    const products = await updateProducts({
      productIds,
      existing: analyticsProducts,
      create: (product) => createAnalyticsProduct(product, experience.id),
    });

    dispatch(setAnalyticsProducts(products));
  }
);

export const createAnalyticsProduct = (
  product: ShopifyProduct,
  experienceId: string | undefined
): AnalyticsProductDto => {
  return {
    id: fromGqlId(product.id),
    experienceId,
    title: product.title,
    image: product.image,
    handle: product.handle,
    variants: product.variants.map((variant) => {
      return {
        id: fromGqlId(variant.id),
        title: variant.title,
      };
    }),
  };
};
